import apiBase from './apiBase';

class PaymentCardApi {
  static get() {
    return apiBase.create().get('/mobile/payment-card');
  }

  static createActivationVerification() {
    return apiBase.create().post('/mobile/payment-card/activation/verification/create');
  }

  static resumeActivationVerification() {
    return apiBase.create().post('/mobile/payment-card/activation/verification/resume');
  }

  static deactivate() {
    return apiBase.create().delete('/mobile/payment-card');
  }
}

export default PaymentCardApi;
